export default class Bibliographic {
    constructor() {
        this.section = document.querySelector('.bibliographic');
        this.groupText = this.section.querySelector('.group')
        this.btnTitle = this.groupText.querySelector('.title')

        this.ready();
    }

    ready() {
        if (this.btnTitle) {
            this.btnTitle.addEventListener('click', () => {
                    this.groupText.classList.toggle('active')
            }, false);
        }
    }
}